// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal avec marge pour la sidebar - Cohérence avec les autres interfaces */
.consommation-page {
  /* margin-left: 230px; */
  padding: 2rem;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 50%, #f5f7fa 100%);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.consommation-page h1 {
  color: #1e293b;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Filtres avec cohérence visuelle */
.filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  padding: 1.5rem;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(79, 70, 229, 0.1);
}

/* Responsive table wrapper */
.table-responsive {
  overflow-x: auto;
  margin-bottom: 2rem;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  background: white;
}

/* Mobile responsive behavior */
@media (max-width: 768px) {
  .table-responsive {
    border-radius: 8px;
  }
  
  .consommation-table {
    min-width: 800px; /* Minimum width to maintain readability */
  }
  
  .filters {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filters select,
  .filters input {
    width: 100%;
    min-width: auto;
  }
}

.filters input {
  padding: 0.875rem 1.25rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-width: 200px;
  flex: 1 1;
}

.filters select {
  padding: 0.875rem 1.25rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-width: 200px;
  flex: 1 1;
}

.filters input:focus,
.filters select:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  transform: translateY(-1px);
}

.filters input::placeholder {
  color: #94a3b8;
  font-style: italic;
}

/* Tableau avec design cohérent */
.consommation-table {
  width: 100%;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-collapse: collapse;
  margin-bottom: 2rem;
}

.consommation-table thead {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #8b5cf6 100%);
}

.consommation-table thead th {
  padding: 1rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: white;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

/* Client column styling - smaller and compact */
.consommation-table thead th:nth-child(2) {
  width: 90px;
  min-width: 90px;
}

.consommation-table tbody td:nth-child(2) {
  width: 90px;
  min-width: 90px;
  font-size: 0.75em;
  padding: 2px 4px;
  word-break: break-word;
}

.consommation-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.consommation-table tbody tr:hover {
  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);
  transform: scale(1.002);
}

.consommation-table tbody tr:last-child {
  border-bottom: none;
}

.consommation-table tbody td {
  padding: 0.875rem 0.75rem;
  color: #374151;
  font-size: 0.8rem;
  vertical-align: middle;
  white-space: nowrap;
}

.consommation-table tbody td:nth-child(7) {
  font-weight: 600;
  color: #10b981;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.05));
  border-radius: 4px;
}

.consommation-table tbody td:nth-child(9) {
  text-transform: capitalize;
  font-weight: 500;
  position: relative;
}

.consommation-table tbody td:nth-child(9)::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  border-radius: 2px;
  background: #f59e0b;
}

.consommation-table tbody tr:hover td:nth-child(9)::before {
  background: #10b981;
}

/* Boutons d'action cohérents */
.action-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
}

.action-buttons button {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.action-buttons button::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: currentColor;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
  opacity: 0.1;
  z-index: -1;
}

.action-buttons button:hover::before {
  width: 100%;
  height: 100%;
}

.action-buttons button:hover {
  transform: scale(1.1);
}

.action-buttons button:first-child:hover {
  background: #dbeafe;
  color: #3b82f6;
}

.action-buttons button:nth-child(2):hover {
  background: #fee2e2;
  color: #ef4444;
}

.action-buttons button:last-child:hover {
  background: #d1fae5;
  color: #10b981;
}

/* Modal overlay cohérent */
.consommation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: consommation-modal-fade-in 0.3s ease;
}

@keyframes consommation-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal avec design unifié */
.consommation-modal {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: consommation-modal-slide-up 0.3s ease;
}

@keyframes consommation-modal-slide-up {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.consommation-modal h2 {
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.consommation-modal p {
  margin: 0.75rem 0;
  color: #374151;
  line-height: 1.6;
  font-size: 0.9rem;
}

.consommation-modal p strong {
  color: #1f2937;
  font-weight: 600;
  display: inline-block;
  min-width: 120px;
}

/* Formulaire dans la modal */
.consommation-modal form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.consommation-modal input {
  padding: 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.consommation-modal input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  transform: translateY(-1px);
}

.consommation-modal input::placeholder {
  color: #9ca3af;
}

/* Actions de modal cohérentes */
.consommation-modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.consommation-modal-actions button {
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  flex: 1 1;
}

.consommation-modal-actions button[type="submit"] {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}

.consommation-modal-actions button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);
}

.consommation-modal-actions button[type="button"] {
  background: #f3f4f6;
  color: #374151;
}

.consommation-modal-actions button[type="button"]:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

/* Bouton fermer cohérent */
.close-button {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  margin-top: 1rem;
}

.close-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(107, 114, 128, 0.3);
}

/* Styles pour les cellules spéciales */
.consommation-table tbody td[colspan="10"] {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 2rem;
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
}

/* Responsive */
@media (max-width: 1024px) {
  .consommation-page {
    margin-left: 0;
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .filters {
    flex-direction: column;
    align-items: stretch;
    padding: 1rem;
  }

  .filters input {
    min-width: auto;
  }

  .consommation-table {
    font-size: 0.7rem;
    overflow-x: auto;
    display: block;
    white-space: nowrap;
  }

  .consommation-table thead,
  .consommation-table tbody,
  .consommation-table th,
  .consommation-table td,
  .consommation-table tr {
    display: block;
  }

  .consommation-table thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .consommation-table tr {
    border: 1px solid #e5e7eb;
    margin-bottom: 1rem;
    border-radius: 8px;
    background: white;
    padding: 1rem;
  }

  .consommation-table td {
    border: none;
    position: relative;
    padding: 0.5rem 0 0.5rem 30%;
    white-space: normal;
  }

  .consommation-table td:before {
    content: attr(data-label);
    position: absolute;
    left: 6px;
    width: 25%;
    padding-right: 10px;
    white-space: nowrap;
    font-weight: 600;
    color: #374151;
  }

  .consommation-modal {
    padding: 1.5rem;
    margin: 1rem;
  }

  .consommation-modal-actions {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .consommation-page h1 {
    font-size: 2rem;
  }

  .filters input {
    font-size: 0.875rem;
  }

  .consommation-modal {
    padding: 1rem;
  }
}

/* Animations pour les interactions */
.consommation-table tbody tr,
.action-buttons button,
.filters input {
  will-change: transform;
}

/* Scrollbar personnalisée cohérente */
.consommation-modal::-webkit-scrollbar {
  width: 6px;
}

.consommation-modal::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.consommation-modal::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.consommation-modal::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* États de chargement */
.consommation-table tbody tr.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Focus visible pour l'accessibilité */
.filters input:focus-visible,
.consommation-modal input:focus-visible,
.consommation-modal-actions button:focus-visible,
.close-button:focus-visible {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

/* Effet de survol sur les lignes avec données importantes */
.consommation-table tbody tr:hover td:nth-child(7) {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border-radius: 4px;
  font-weight: 700;
}

/* Style pour les messages d'alerte cohérents */
.consommation-alert {
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-weight: 500;
}

.consommation-alert.success {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border-left: 4px solid #10b981;
}

.consommation-alert.error {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border-left: 4px solid #ef4444;
}

.consommation-alert.warning {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #d97706;
  border-left: 4px solid #f59e0b;
}

/* Style pour les valeurs numériques importantes */
.consommation-table tbody td:nth-child(4),
.consommation-table tbody td:nth-child(5),
.consommation-table tbody td:nth-child(6) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-weight: 500;
}

/* Bouton d'ajout avec style cohérent */
.consommation-btn-primary {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  white-space: nowrap;
}

.consommation-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
}

.consommation-btn-primary:active {
  transform: translateY(0);
}

`, "",{"version":3,"sources":["webpack://./src/styles/Consommation.css"],"names":[],"mappings":"AAAA,0FAA0F;AAC1F;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,0EAA0E;EAC1E,uFAAuF;AACzF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB,EAAE,0CAA0C;EAC9D;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,SAAO;AACT;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qFAAqF;EACrF,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;EAChC,6CAA6C;EAC7C,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,6DAA6D;AAC/D;;AAEA,eAAe;AACf;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;;;;;IAKE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC;;;EAGE,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;;;EAGE,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Container principal avec marge pour la sidebar - Cohérence avec les autres interfaces */\n.consommation-page {\n  /* margin-left: 230px; */\n  padding: 2rem;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 50%, #f5f7fa 100%);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.consommation-page h1 {\n  color: #1e293b;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #3b82f6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Filtres avec cohérence visuelle */\n.filters {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 1.5rem;\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(79, 70, 229, 0.1);\n}\n\n/* Responsive table wrapper */\n.table-responsive {\n  overflow-x: auto;\n  margin-bottom: 2rem;\n  border-radius: 16px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  background: white;\n}\n\n/* Mobile responsive behavior */\n@media (max-width: 768px) {\n  .table-responsive {\n    border-radius: 8px;\n  }\n  \n  .consommation-table {\n    min-width: 800px; /* Minimum width to maintain readability */\n  }\n  \n  .filters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .filters select,\n  .filters input {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n.filters input {\n  padding: 0.875rem 1.25rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 0.875rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  min-width: 200px;\n  flex: 1;\n}\n\n.filters select {\n  padding: 0.875rem 1.25rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 0.875rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  min-width: 200px;\n  flex: 1;\n}\n\n.filters input:focus,\n.filters select:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n  transform: translateY(-1px);\n}\n\n.filters input::placeholder {\n  color: #94a3b8;\n  font-style: italic;\n}\n\n/* Tableau avec design cohérent */\n.consommation-table {\n  width: 100%;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border-collapse: collapse;\n  margin-bottom: 2rem;\n}\n\n.consommation-table thead {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #8b5cf6 100%);\n}\n\n.consommation-table thead th {\n  padding: 1rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: white;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n/* Client column styling - smaller and compact */\n.consommation-table thead th:nth-child(2) {\n  width: 90px;\n  min-width: 90px;\n}\n\n.consommation-table tbody td:nth-child(2) {\n  width: 90px;\n  min-width: 90px;\n  font-size: 0.75em;\n  padding: 2px 4px;\n  word-break: break-word;\n}\n\n.consommation-table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.consommation-table tbody tr:hover {\n  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);\n  transform: scale(1.002);\n}\n\n.consommation-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.consommation-table tbody td {\n  padding: 0.875rem 0.75rem;\n  color: #374151;\n  font-size: 0.8rem;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.consommation-table tbody td:nth-child(7) {\n  font-weight: 600;\n  color: #10b981;\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.05));\n  border-radius: 4px;\n}\n\n.consommation-table tbody td:nth-child(9) {\n  text-transform: capitalize;\n  font-weight: 500;\n  position: relative;\n}\n\n.consommation-table tbody td:nth-child(9)::before {\n  content: \"\";\n  position: absolute;\n  left: -8px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 4px;\n  height: 20px;\n  border-radius: 2px;\n  background: #f59e0b;\n}\n\n.consommation-table tbody tr:hover td:nth-child(9)::before {\n  background: #10b981;\n}\n\n/* Boutons d'action cohérents */\n.action-buttons {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.action-buttons button {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.action-buttons button::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  background: currentColor;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  transition: width 0.3s ease, height 0.3s ease;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.action-buttons button:hover::before {\n  width: 100%;\n  height: 100%;\n}\n\n.action-buttons button:hover {\n  transform: scale(1.1);\n}\n\n.action-buttons button:first-child:hover {\n  background: #dbeafe;\n  color: #3b82f6;\n}\n\n.action-buttons button:nth-child(2):hover {\n  background: #fee2e2;\n  color: #ef4444;\n}\n\n.action-buttons button:last-child:hover {\n  background: #d1fae5;\n  color: #10b981;\n}\n\n/* Modal overlay cohérent */\n.consommation-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: consommation-modal-fade-in 0.3s ease;\n}\n\n@keyframes consommation-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal avec design unifié */\n.consommation-modal {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: consommation-modal-slide-up 0.3s ease;\n}\n\n@keyframes consommation-modal-slide-up {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.consommation-modal h2 {\n  color: #1e293b;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #3b82f6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.consommation-modal p {\n  margin: 0.75rem 0;\n  color: #374151;\n  line-height: 1.6;\n  font-size: 0.9rem;\n}\n\n.consommation-modal p strong {\n  color: #1f2937;\n  font-weight: 600;\n  display: inline-block;\n  min-width: 120px;\n}\n\n/* Formulaire dans la modal */\n.consommation-modal form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.consommation-modal input {\n  padding: 0.875rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.consommation-modal input:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n  transform: translateY(-1px);\n}\n\n.consommation-modal input::placeholder {\n  color: #9ca3af;\n}\n\n/* Actions de modal cohérentes */\n.consommation-modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.consommation-modal-actions button {\n  padding: 0.875rem 1.5rem;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  flex: 1;\n}\n\n.consommation-modal-actions button[type=\"submit\"] {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n}\n\n.consommation-modal-actions button[type=\"submit\"]:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);\n}\n\n.consommation-modal-actions button[type=\"button\"] {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.consommation-modal-actions button[type=\"button\"]:hover {\n  background: #e5e7eb;\n  transform: translateY(-1px);\n}\n\n/* Bouton fermer cohérent */\n.close-button {\n  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 1.5rem;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n  margin-top: 1rem;\n}\n\n.close-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(107, 114, 128, 0.3);\n}\n\n/* Styles pour les cellules spéciales */\n.consommation-table tbody td[colspan=\"10\"] {\n  text-align: center;\n  color: #6b7280;\n  font-style: italic;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .consommation-page {\n    margin-left: 0;\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .filters {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 1rem;\n  }\n\n  .filters input {\n    min-width: auto;\n  }\n\n  .consommation-table {\n    font-size: 0.7rem;\n    overflow-x: auto;\n    display: block;\n    white-space: nowrap;\n  }\n\n  .consommation-table thead,\n  .consommation-table tbody,\n  .consommation-table th,\n  .consommation-table td,\n  .consommation-table tr {\n    display: block;\n  }\n\n  .consommation-table thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  .consommation-table tr {\n    border: 1px solid #e5e7eb;\n    margin-bottom: 1rem;\n    border-radius: 8px;\n    background: white;\n    padding: 1rem;\n  }\n\n  .consommation-table td {\n    border: none;\n    position: relative;\n    padding: 0.5rem 0 0.5rem 30%;\n    white-space: normal;\n  }\n\n  .consommation-table td:before {\n    content: attr(data-label);\n    position: absolute;\n    left: 6px;\n    width: 25%;\n    padding-right: 10px;\n    white-space: nowrap;\n    font-weight: 600;\n    color: #374151;\n  }\n\n  .consommation-modal {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n\n  .consommation-modal-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .consommation-page h1 {\n    font-size: 2rem;\n  }\n\n  .filters input {\n    font-size: 0.875rem;\n  }\n\n  .consommation-modal {\n    padding: 1rem;\n  }\n}\n\n/* Animations pour les interactions */\n.consommation-table tbody tr,\n.action-buttons button,\n.filters input {\n  will-change: transform;\n}\n\n/* Scrollbar personnalisée cohérente */\n.consommation-modal::-webkit-scrollbar {\n  width: 6px;\n}\n\n.consommation-modal::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.consommation-modal::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.consommation-modal::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* États de chargement */\n.consommation-table tbody tr.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Focus visible pour l'accessibilité */\n.filters input:focus-visible,\n.consommation-modal input:focus-visible,\n.consommation-modal-actions button:focus-visible,\n.close-button:focus-visible {\n  outline: 2px solid #4f46e5;\n  outline-offset: 2px;\n}\n\n/* Effet de survol sur les lignes avec données importantes */\n.consommation-table tbody tr:hover td:nth-child(7) {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  border-radius: 4px;\n  font-weight: 700;\n}\n\n/* Style pour les messages d'alerte cohérents */\n.consommation-alert {\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n\n.consommation-alert.success {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #059669;\n  border-left: 4px solid #10b981;\n}\n\n.consommation-alert.error {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #dc2626;\n  border-left: 4px solid #ef4444;\n}\n\n.consommation-alert.warning {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  color: #d97706;\n  border-left: 4px solid #f59e0b;\n}\n\n/* Style pour les valeurs numériques importantes */\n.consommation-table tbody td:nth-child(4),\n.consommation-table tbody td:nth-child(5),\n.consommation-table tbody td:nth-child(6) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-weight: 500;\n}\n\n/* Bouton d'ajout avec style cohérent */\n.consommation-btn-primary {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 1.5rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n  white-space: nowrap;\n}\n\n.consommation-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);\n}\n\n.consommation-btn-primary:active {\n  transform: translateY(0);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
